module.exports = __webpack_public_path__ + "img/jztficon.64aa9fde.svg";